
const storeObj = {
    state: {
        progress : false,
        loginInfo : null,
        modals: [],
        smallModalView : null,
        modalTransitionName : 'right', //'right' 오른쪽에서 왼쪽으로, '' 바로나타남, 'bottom'
        leftMenuModals : [],
        leftMenuTransitionName : 'leftmenuright', // leftmenuright 오른쪽에서 왼쪽으로
        refreshMemberInfo : {},
        alertMessage : '',
        isShowAlert : false,
        centerInfo : null,
        noRouterReload : true,
        isLeftMenuAnimationOn : false,
        modalInstance : null,
        pagePopFlags : [],
        confirmTitle: '',
        confirmOkCallBack : {},
        confirmCancelCallBack: {},
        confirmOkName : '',
        confirmCancelName : '',
        isShowConfirm: false
    },
    mutations: {
        hideConfirm(state) {
            state.isShowConfirm = false
        },
        showConfirm(state, data) {
            state.isShowConfirm = true
            state.confirmTitle = data.title
            state.confirmOkCallBack = data.okCallBack
            state.confirmOkName = data.okName
            state.confirmCancelName = data.cancelName
            state.confirmCancelCallBack = data.cancelCallBack
        },
        showSystemPatch(state) {
            state.systemPatch = true
        },
        hideSystemPatch(state) {
            state.completeUpdate = true
            setTimeout(() => {
                state.systemPatch = false
            }, 1500)
        },
        showProModal(state) {
            setTimeout(() => {
                state.proModal = true
            },3000)
        },
        hideProModal(state) {
            state.proModal = false
        },
        showProgress (state){
            state.progress = true;
        },
        hideProgress(state){
            state.progress = false;
        },
        setLoginInfo(state, loginInfo){
            state.loginInfo = loginInfo;
        },
        setChatLoginInfo(state, chatLoginInfo){
            state.chatLoginInfo = chatLoginInfo;
        },
        logout(state){
            state.loginInfo = null;
        },
        addModal (state, data) {
            if(Object.prototype.hasOwnProperty.call(data, 'transitionName')){
                state.modalTransitionName = data.transitionName;
            }else {
                state.modalTransitionName = 'right';
            }

            state.modals.push(data);
        },
        closeLastModal (state){
            if(state.modals.length === 0) return;
                const lastModal = state.modals[state.modals.length - 1];

            if(Object.prototype.hasOwnProperty.call(lastModal, 'transitionName')){
                state.modalTransitionName = lastModal.transitionName;
            }else {
                state.modalTransitionName = 'right';
            }

            if(Object.prototype.hasOwnProperty.call(lastModal, 'closeAction')){
                lastModal.closeAction();
            }

            state.modals.pop();
        },
        changeLastModal(state, data){
            state.modals.pop();
            state.modals.push(data);
        },
        closeLastModalLoop(state, data) {
            for (let i = 0; i < data.data; i++) {
                state.modals.pop()
            }
        },
        closeSpliceModal(state, data) {
            for (let i = 0; i < state.modals.length; i++) {
                if (state.modals[i].view === data.data) {
                    if(Object.prototype.hasOwnProperty.call(state.modals[i], 'closeAction')){
                        state.modals[i].closeAction();
                    }
                    state.modals.splice(i)
                }
                
            }
        },
        closeModalAll(state){
            state.modals = [];
        },
        addPopFlag(state, closeFunction){
            const modalLength = state.modals.length;

            if(modalLength > 0){
                const lastModal = state.modals[modalLength - 1];

                if(!Object.prototype.hasOwnProperty.call(lastModal, 'popFlags')){
                    lastModal.popFlags = []
                }
                lastModal.popFlags.push(closeFunction);
            }else {
                state.pagePopFlags.push(closeFunction);
            }
        },
        closeLastPop(state, isExecuteCloseAction){
            const modalLength = state.modals.length;
            //page 화면 popup 닫기
            if(modalLength === 0) {
                if(state.pagePopFlags.length > 0){
                    if(isExecuteCloseAction) (state.pagePopFlags[state.pagePopFlags.length - 1])();
                    state.pagePopFlags.pop();
                }
                return;
            }

            let lastModal = state.modals[modalLength - 1];
            if(!lastModal.popFlags) return;
            let lastModalPopLength = lastModal.popFlags.length;
            if(lastModalPopLength === 0) return;
            if(isExecuteCloseAction) (lastModal.popFlags[lastModalPopLength - 1])();
            lastModal.popFlags.pop();
        },
        changeModalTransition(state, to){
            state.modalTransitionName = to;
        },
        changeLeftMenuTransition(state, to){
            state.leftMenuTransitionName = to;
        },
        showAlert(state, msg){
            state.alertMessage = msg;
            state.isShowAlert = true;
            alert(msg); /* TODO 나중에 알럿화면 추가되면 지울것*/
        },
        hideAlert(state){
            state.alertMessage = '';
            state.isShowAlert = false;
        },
        setLastModalFixedInIOS(state, top, height){
            window.webkit.messageHandlers.ios.postMessage({cmd : 'setScrollEnabled', flag: 'false'});
            const lastModalEl = state.modalInstance.$refs['modalRef' + (state.modals.length - 1)][0];
            lastModalEl.style.height = height + 'px';
            lastModalEl.style.top = top + 'px';
        },
        unsetLastModalFixedInIOS(state){
            window.webkit.messageHandlers.ios.postMessage({cmd : 'setScrollEnabled', flag: 'true'});
            const lastModalEl = state.modalInstance.$refs['modalRef' + (state.modals.length - 1)][0];
            lastModalEl.style.height = 'unset';
            lastModalEl.style.top ='0';
        },
    },
    actions : {
    },
    getters: {
        lastModalData: state => {
            return state.modals[state.modals.length - 1];
        },
        modalLength: state => {
            return state.modals.length;
        },
        isLogin : state => {
            return state.loginInfo == null ? false : true;
        },
    }
};
export default storeObj;